export default ({ request }) => ({
  addCartApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCart/add',
      method: 'post',
      data
    })
  },
  delCartApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCart/del',
      method: 'post',
      data
    })
  },
  sampleListCartApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCart/sampleList',
      method: 'post',
      data
    })
  },
  deListCartApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCart/deList',
      method: 'post',
      data
    })
  },
  resListCartApi (data = {}) {
    return request({
      url: '/digitalCenter/shopProductCart/resList',
      method: 'post',
      data
    })
  }
})
